import { GET_PLC_SAFETY_CAUSES, GET_PLC_SAFETY_CAUSES_SUCCESS, GET_PLC_SAFETY_CAUSES_ERROR } from './actionTypes';

export const getPlcSafetyCauses = (user, size, page, status) => ({
  type: GET_PLC_SAFETY_CAUSES,
  payload: { user, size, page, status },
});

export const getPlcSafetyCausesSuccess = (causes, message) => ({
  type: GET_PLC_SAFETY_CAUSES_SUCCESS,
  payload: { causes, message },
});

export const getPlcSafetyCausesError = (error) => ({
  type: GET_PLC_SAFETY_CAUSES_ERROR,
  payload: error,
});
